import {config, lm_} from "../../../appContext";
import {AvailableLanguages, ILanguage} from "../../../constants/Language";
import {LanguageInstance} from "../../../util/LanguageManager";
import * as ko from "knockout";
import language_pickerHtml from './language-picker.html?raw';

export const template = language_pickerHtml;

export class viewModel {
    readonly AvailableLanguages = AvailableLanguages.filter(o => config.AVAILABLE_LANGUAGES.includes(o.key))
    readonly languageInstance: LanguageInstance = lm_.getInstance()
    readonly selectedLanguage: KnockoutObservable<ILanguage> = lm_.selectedLanguage
    readonly isWaiting = this.languageInstance.promiseRequest.isRequesting
    readonly isOpen = ko.observable(false)

    private readonly onBodyClick = () => { if (this.isOpen()) this.isOpen(false) }

    constructor() {
        document.addEventListener('click', this.onBodyClick)
    }

    dispose(): void {
        document.removeEventListener('click', this.onBodyClick)
    }

    toggleOpen(): void {
        this.isOpen(!this.isOpen())
    }

    setLanguage(lang: ILanguage): void {
        this.selectedLanguage(lang)
        this.isOpen(false)
    }

    onContainerClick(_: viewModel, event: MouseEvent): boolean {
        event.stopPropagation()
        return true
    }
}
